import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { PageHeader } from 'mailup-web-components'
import { useNavigate } from 'react-router-dom'

const Header: FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
      'data-mu-test': 'breadcrumb-item__recipients',
      onClick: Function.prototype,
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Import' }),
      'data-mu-test': 'breadcrumb-item__import',
      onClick: () => {
        navigate('/recipients/import')
      },
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.New' }),
      'data-mu-test': 'breadcrumb-item__import__new',
      onClick: () => {
        navigate('/recipients/import')
      },
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ImportFattureInCloud' }),
      'data-mu-test': 'breadcrumb-item__import__fatture-in-cloud',
    },
  ]

  return (
    <PageHeader
      title={intl.formatMessage({ id: 'Load.NavMenu.ImportFattureInCloud' })}
      breadcrumbsItems={breadcrumbsItems}
      menuItems={undefined}
    />
  )
}

export default Header
